module.exports = __webpack_public_path__ + "img/loginbg.1e8320bc.jpg";